import { render, staticRenderFns } from "./my-popover.vue?vue&type=template&id=0af5c47b&scoped=true"
import script from "./my-popover.vue?vue&type=script&lang=js"
export * from "./my-popover.vue?vue&type=script&lang=js"
import style0 from "./my-popover.vue?vue&type=style&index=0&id=0af5c47b&prod&scoped=true&lang=css"
import style1 from "./my-popover.vue?vue&type=style&index=1&id=0af5c47b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5c47b",
  null
  
)

export default component.exports